export default function Switch({
  enabled,
  handleChange,
  label,
}: {
  enabled: boolean;
  handleChange: (boolean) => void;
  label: string;
}) {
  return (
    <>
      <label className="relative flex justify-between items-center text-md gap-2">
        {label}
        <input
          type="checkbox"
          className="absolute left-1/2 -translate-x-1/2 peer appearance-none rounded-md"
          checked={enabled}
          onChange={() => handleChange(!enabled)}
        />
        <span className="flex items-center flex-shrink-0 ml-2 bg-gray-300 rounded-full duration-300 ease-in-out peer-checked:bg-[#43d662] w-10 after:w-6 h-5 after:h-5 after:bg-white after:rounded-full after:shadow-md after:duration-300 peer-checked:after:translate-x-4"></span>
      </label>
    </>
  );
}
